import { Link } from 'react-router-dom';
import { useContext } from 'react';
import axios from 'axios';
import CurrentUserContext from '../contexts/CurrentUserContext';
import Profile from '../images/profile.svg';
import './UserDetails.css';

function UserDetails() {
  const { currentUser, setCurrentUser } = useContext(CurrentUserContext);
  const username = currentUser?.username;
  console.log('currentUser:', currentUser, 'username:', username);
  const logout = async () => {
    try {
      await axios.post('/api/auth/logout', {});
      setCurrentUser({});
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div className="user-details-component">
      {username ? (
        <div>
          {currentUser.access === 'associate' ? <Link to="/orders">Orders</Link> : null}
          <img src={Profile} alt="Profile" />
          <p>{username}</p>
          <button onClick={logout} type="button">Log Out</button>
        </div>
      ) : <Link to="/login">Login</Link>}
    </div>
  );
}

export default UserDetails;
